import {
  Box,
  CircularProgress
} from '@mui/material';
import { useAuthStateSuspenseQuery } from 'generated/graphql';
import {
  HeaderNavbar,
  SuperAdminRoute
} from 'modules';
import React, { Suspense } from 'react';
import {
  Navigate,
  Outlet
} from 'react-router-dom';



export type AdminLayoutProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const AdminLayout = (props: AdminLayoutProps) => {
  return (


    <Box
      display='flex'
      flexDirection='column'
      paddingX='1.5rem'
    >
      <HeaderNavbar.FC />
      <SuperAdminRoute.FC />
    </Box>

  );

};
